export class TransactionSearchModel {
  id: string;
  type: string;
  type_description: string;
  occurred_at: string;
  amount: number;
  reference: string;
  running_balance_amount: number;
}
